export const name = 'pricingPlansWixCodeSdk' as const
export const namespace = 'pricing-plans' as const
